// AdminBrandingPage — upload de logo + edição de cores e nome da empresa
import { useEffect, useState, useRef } from 'react';
import { admin, branding as brandingApi } from '../../lib/api.js';

export default function AdminBrandingPage() {
  const [params, setParams] = useState([]);
  const [editing, setEditing] = useState({});
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  async function recarregar() {
    const r = await admin.listarParametros();
    const branding = (r.data || []).filter(p => p.chave.startsWith('branding.'));
    setParams(branding);
    const ed = {};
    branding.forEach(p => { ed[p.chave] = p.valor; });
    setEditing(ed);
  }

  useEffect(() => { recarregar(); }, []);

  async function salvar(chave) {
    try {
      await admin.atualizarParametro(chave, editing[chave]);
      await recarregar();
      alert(`✓ ${chave} atualizado`);
    } catch (e) { alert(e.uiMessage); }
  }

  async function onPickFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      alert('Arquivo grande demais (max 2MB)');
      return;
    }
    const fd = new FormData();
    fd.append('logo', file);
    setUploading(true);
    try {
      await admin.uploadLogo(fd);
      await recarregar();
      // Força reload da branding em outras telas (sem recarregar a página inteira)
      window.dispatchEvent(new CustomEvent('branding-updated'));
      alert(`✓ Logo atualizada (${(file.size / 1024).toFixed(0)} KB)`);
    } catch (e) { alert(e.uiMessage || 'Erro no upload'); }
    setUploading(false);
    if (fileRef.current) fileRef.current.value = '';
  }

  const logoUrl = editing['branding.logo_url'];
  const corPri = editing['branding.cor_primaria'];

  return (
    <div className="stack">
      <h1>Marca</h1>
      <p style={{ color: '#6b7280', marginTop: -8, marginBottom: 24 }}>
        Logo, cores e nome da empresa exibidos no Field Service.
      </p>

      <div className="card" style={{ padding: 20, marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>Logo</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
          <div style={{
            width: 120, height: 120, background: '#f9fafb',
            border: '1px solid #e5e7eb', borderRadius: 12,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            overflow: 'hidden',
          }}>
            {logoUrl && <img src={logoUrl + '?t=' + Date.now()} alt="logo" style={{ maxWidth: '90%', maxHeight: '90%' }} />}
          </div>
          <div style={{ flex: 1, minWidth: 280 }}>
            <p style={{ marginTop: 0, fontSize: 13, color: '#4b5563' }}>
              Aceita SVG, PNG, JPEG ou WebP (máx 2MB). O ideal é SVG ou PNG transparente.
            </p>
            <input
              ref={fileRef}
              type="file"
              accept="image/svg+xml,image/png,image/jpeg,image/webp"
              onChange={onPickFile}
              disabled={uploading}
              style={{ marginBottom: 8 }}
            />
            <div style={{ fontSize: 11, color: '#6b7280' }}>
              URL atual: <code>{logoUrl}</code>
            </div>
            {uploading && <p style={{ color: '#1e3a8a', fontSize: 13 }}>Enviando...</p>}
          </div>
        </div>
      </div>

      <div className="card" style={{ padding: 20, marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>Cores da marca</h3>
        {['branding.cor_primaria', 'branding.cor_secundaria', 'branding.cor_destaque'].map(chave => {
          const p = params.find(x => x.chave === chave);
          if (!p) return null;
          const valor = editing[chave] || '';
          return (
            <div key={chave} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
              <label style={{ flex: '0 0 140px', fontSize: 13 }}>{chave.replace('branding.cor_', '')}</label>
              <input
                type="color"
                value={valor}
                onChange={e => setEditing({...editing, [chave]: e.target.value})}
                style={{ width: 50, height: 32, border: '1px solid #e5e7eb', borderRadius: 6, cursor: 'pointer' }}
              />
              <input
                type="text"
                value={valor}
                onChange={e => setEditing({...editing, [chave]: e.target.value})}
                style={{ width: 120, padding: '4px 8px', fontFamily: 'monospace', fontSize: 12 }}
              />
              <button className="btn small primary" onClick={() => salvar(chave)} disabled={valor === p.valor}>
                Salvar
              </button>
            </div>
          );
        })}
      </div>

      <div className="card" style={{ padding: 20 }}>
        <h3 style={{ marginTop: 0 }}>Identidade</h3>
        {['branding.nome_empresa', 'branding.tagline'].map(chave => {
          const p = params.find(x => x.chave === chave);
          if (!p) return null;
          const valor = editing[chave] || '';
          return (
            <div key={chave} style={{ marginBottom: 10 }}>
              <label style={{ display: 'block', fontSize: 13, marginBottom: 4 }}>
                {chave === 'branding.nome_empresa' ? 'Nome da empresa' : 'Tagline'}
              </label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  type="text"
                  value={valor}
                  onChange={e => setEditing({...editing, [chave]: e.target.value})}
                  style={{ flex: 1, padding: '6px 10px' }}
                />
                <button className="btn small primary" onClick={() => salvar(chave)} disabled={valor === p.valor}>
                  Salvar
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
